import { request } from "./index";
import Filter from "@/store/filter";
const brand_portfolio = {
  state: {
    list: [],
    budget_strategies: [],
    parent_workspace_to_child_workspace_map: new Map(),
    sellers_filter: new Filter([], [], 'id')
  },
  getters: {
    brandPortfolioListGet(state) {
      return state.list;
    }
  },
  mutations: {
    brandPortfolioListSet(state, payload) {
      state.list = payload;
    },
    brandPortfolioBudgetStrategiesSet(state, payload) {
      state.budget_strategies = payload;
    },
    brandPortfolioSellersFilterSet(state, payload) {
      state.sellers_filter.restore(payload);
    },
    brandPortfolioParentsMapSet(state, payload) {
      state.parent_workspace_to_child_workspace_map = payload;
    }
  },
  actions: {
    async brandPortfolioList({
      commit
    }, payload) {
      const data = await request("/brandportfolio", "POST", payload);
      if (data) {
        commit("brandPortfolioListSet", data.data || []);
      }
      return data;
    },
    async brandPortfolioGetCurrentWeekBudgetStrategies({
      commit
    }, payload) {
      const result = await request("/ppc/settings/budget_strategy/get_current_week_batch", "POST", payload);
      commit("brandPortfolioBudgetStrategiesSet", result?.data ?? []);
      return result?.data ?? [];
    }
  }
};
export default brand_portfolio;